/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Record_Actions_LabelInputs */



/**
* | output |
* | --- |
* | "Record actions" |
*
* @param {Explorer_Info_Record_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_record_actions_label = /** @type {((inputs?: Explorer_Info_Record_Actions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Record_Actions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actions d'enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktionen aufzeichnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra le azioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись действий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar acciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("记录操作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクションを記録する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड क्रियाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ações de registro")
	return /** @type {LocalizedString} */ ("Record actions")
});